import type { InitialCarePlan } from '@seen/core/models/care-plans/InitialCarePlan'
import { Badge } from '@seen/ui'
import type { JSX } from 'react'
import { ResourceFieldForm } from '#src/components/core/form/ResourceFieldForm.tsx'
import { RichTextEditor } from '#src/components/rich-text-editor/RichTextEditor.tsx'

interface CarePlanWhatMattersMostProps {
  carePlan: InitialCarePlan
}

export function CarePlanWhatMattersMost({
  carePlan,
}: CarePlanWhatMattersMostProps): JSX.Element {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex">
        <Badge variant="secondary" className="justify-self-start">
          What Matters Most
        </Badge>
      </div>
      <ResourceFieldForm
        instance={carePlan}
        valueFn={(carePlan) => carePlan.description}
        patchFn={(patchCarePlan, sanitizedHtml) => {
          patchCarePlan.description = sanitizedHtml
        }}
        disabled={!carePlan.isEditable}
        debounceTyping
        render={({ field: { value, ...rest } }) => (
          <RichTextEditor
            defaultValue={value}
            placeholder="Describe what matters the most to the participant..."
            variant="lead"
            className="text-foreground-secondary"
            {...rest}
          />
        )}
      />
    </div>
  )
}
